module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAnUlEQVR4AWOgC/hPNMCi4eue/a/Lay/YuAARkAHkEtDwav2mC4paGxXUgQjIAHIJaLhTWjVRS3+ungkQARlALgENT8PjbsqoPjK1A6IbMqpALgENB3VNtjNwzmbgACIgA8gloGGfuV0jA3unBHu3FDuQAeRi0XCLgQcNPXHnfeLKgymOU8NjZ97H9rykaXhoTIoNb7t4H+pj0zAoAQBXght/sJh37QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GI.png
// module id = 1148
// module chunks = 0